export const URL_ROOT = 'URL_ROOT'

export const URL_USER_DASHBOARD = 'URL_USER_DASHBOARD'
export const URL_USER_PARTICIPATE_DASHBOARD = 'URL_USER_PARTICIPATE_DASHBOARD'
export const URL_USER_ORGANIZE_DASHBOARD = 'URL_USER_ORGANIZE_DASHBOARD'
export const URL_ADMIN_GATHERING_DASHBOARD = 'URL_ADMIN_GATHERING_DASHBOARD'
export const URL_ADMIN_BUSINESS_DASHBOARD = 'URL_ADMIN_BUSINESS_DASHBOARD'
export const URL_ADMIN_BUSINESS_REPORT = 'URL_ADMIN_BUSINESS_REPORT'
export const URL_ADMIN_STATS_DASHBOARD = 'URL_ADMIN_STATS_DASHBOARD'
export const URL_ADMIN_SUPERADMIN_DASHBOARD = 'URL_ADMIN_SUPERADMIN_DASHBOARD'

export const URL_ACCOUNT_FORGOT_PASSWORD = 'URL_ACCOUNT_FORGOT_PASSWORD'
export const URL_ACCOUNT_EDIT_INFORMATIONS = 'URL_ACCOUNT_EDIT_INFORMATIONS'
export const URL_ACCOUNT_LOGIN = 'URL_ACCOUNT_LOGIN'
export const URL_ACCOUNT_RESET_PASSWORD = 'URL_ACCOUNT_RESET_PASSWORD'
export const URL_ACCOUNT_SUBSCRIBE = 'URL_ACCOUNT_SUBSCRIBE'
export const URL_LOGOUT = 'URL_LOGOUT'

export const URL_CREATE_BUSINESS = 'URL_CREATE_BUSINESS'
export const URL_EDIT_BUSINESS = 'URL_EDIT_BUSINESS'

export const URL_CREATE_GATHERING = 'URL_CREATE_GATHERING'
export const URL_EDIT_GATHERING = 'URL_EDIT_GATHERING'
export const URL_GATHERING_SUBMITTED = 'URL_GATHERING_SUBMITTED'

export const URL_ENCOURAGE = 'URL_ENCOURAGE'
